import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import i18next from 'i18next'

import { error } from 'src/components/system_wide/notification'

import axios from 'src/lib/axios'

const { t } = i18next

const initialState = {
  total: 0,
  appointments: [],
  pending: false,
  show_form: false,
  current_appointment: null,
}

export const getAppointments = createAsyncThunk(
  'calendar/appointmentsList',
  async (
    { start_date, end_date, filtered_brands, filtered_statuses, filtered_users, filtered_appointment_types },
    thunkApi
  ) => {
    try {
      let response = await axios({
        url: `/api/appointments/calendar`,
        params: {
          start_date,
          end_date,
          filtered_brands: filtered_brands.join(','),
          filtered_statuses: filtered_statuses.join(','),
          filtered_users: filtered_users.join(','),
          filtered_appointment_types: filtered_appointment_types.join(','),
        },
      })
      let { appointments } = response.data
      return { appointments }
    } catch (err) {
      error(t('store.appointments.get_appointments_error', 'Impossibile recuperare lista visite'))
      return thunkApi.rejectWithValue()
    }
  }
)

export const calendarSlice = createSlice({
  name: 'calendar',
  initialState,

  reducers: {
    setCurrentAppointment: (state, action) => {
      let {
        id,
        code,
        piva,
        business_name,
        date,
        address,
        city,
        province,
        cap,
        country,
        lat,
        lng,
        place_id,
        ref_phone,
        ref_email,
        ref_name,
        ref_surname,
        status,
        rejected_note,
        note,
        created_by,
        handled_by,
        handled_at,
        success_at,
        rejected_at,
        brand_id,
        merchandise_category_id,
        photos,
        created_at,
        updated_at,
      } = action.payload
      state.current_appointment = {
        id,
        code,
        piva,
        business_name,
        date,
        address,
        city,
        province,
        cap,
        country,
        lat,
        lng,
        place_id,
        ref_phone,
        ref_email,
        ref_name,
        ref_surname,
        status,
        rejected_note,
        note,
        created_by,
        handled_by,
        handled_at,
        success_at,
        rejected_at,
        brand_id,
        merchandise_category_id,
        photos,
        created_at,
        updated_at,
      }
    },
    toggleShowForm: state => {
      state.show_form = !state.show_form
    },
    resetCurrentAppointment: state => {
      state.current_appointment = initialState.current_appointment
    },
    resetAppointments: () => initialState,
  },

  extraReducers: {
    [getAppointments.fulfilled]: (state, action) => {
      if (!action?.payload) return
      let { appointments } = action.payload
      state.appointments = appointments
      state.pending = false
    },
    [getAppointments.pending]: state => {
      state.pending = true
    },
    [getAppointments.rejected]: state => {
      state.appointments = initialState.appointments
      state.pending = false
    },
  },
})

export const { setCurrentAppointment, resetCurrentAppointment, toggleShowForm, resetAppointments } =
  calendarSlice.actions
export default calendarSlice.reducer
